<div class="col itemsContainer d-print-block-visible">
    <div class="row report-controls">
        <div class="col-2" *ngIf="showCommandButtons()">
            <input class="btn btn-primary" type="button" (click)="goBack()" value="Back" />
        </div>
        <div [ngClass]="{'col-8': showCommandButtons(),  'col-12 text-center': !showCommandButtons()}">
            <h1 class="h1-responsive report-name text-center">{{result?.asset.title}}</h1>
        </div>
        <div class="col-2 ml-auto" *ngIf="showCommandButtons()">
            <input class="btn btn-secondary" type="button" (click)="print()" value="Download PDF" />
        </div>
    </div>
    <div class="row d-none d-print-block-visible">
        <div class='col-12 text-center'>
            <h1 class="h1-responsive report-name text-center">{{result?.asset.title}}</h1>
        </div>
    </div>
    <div class="row" *ngIf="!hasLoadedResults">
        <div class="col">
            <p class="alert alert-warning">
                <app-spin-icon></app-spin-icon> Loading Report data...
            </p>
        </div>
    </div>
    <p class="text-center offset-2 col-8"><i>{{result.asset.description}}</i></p>
    <dac-exercise class="card card-body" *ngIf="shouldDisplayExercise()" [exercise]="result.asset" [result]="result" [hideHeaders]="disableAsset" [disabled]="disableAsset">
    </dac-exercise>
    <dac-article class="card card-body" *ngIf="shouldDisplayArticle()" [article]="result.asset" [result]="result" [hideHeaders]="disableAsset" [disabled]="disableAsset">
    </dac-article>
</div>
<dac-print-dialog [isOpen]="showPrintDialog" [hideNotesOption]="'true'" (close)="closePrintDialog()"></dac-print-dialog>


// WEBPACK FOOTER //
// ./src/app/reports/asset-result-view/asset-result-view.component.html